import { PayloadAction } from '@reduxjs/toolkit';
import { HeaderType } from '../types';

export const changeSlide = (state: HeaderType, action: PayloadAction<number>) => {
  state.currentSlide = action.payload
};
